module.exports = __webpack_public_path__ + "static/media/google-play.40b5895e.png";